import { Accept } from 'react-dropzone'
import { MediaFileProps } from '../types'

export const getPaginatedMediaLibraryData = (
	data: MediaFileProps[],
	pageNumber: number,
	pageSize: number
) => {
	const startIndex = (pageNumber - 1) * pageSize
	const endIndex = startIndex + pageSize
	return data.slice(startIndex, endIndex)
}

export const isValidFileType = (file: File, accept?: Accept) => {
	const fileType = file.type
	if (!accept || Object.keys(accept).length === 0) {
		return true // No restrictions, all files are valid
	}

	return Object.keys(accept).includes(fileType)
}

export const filterMediaByFolder = (
	data: MediaFileProps[],
	folder: string
) => {
	return data.filter((mediaFile) => mediaFile.parentFolder === folder)
}

export const truncateFolderName = (
	name: string,
	maxLength: number = 35
) => {
	if (!name) return 'Unassigned'
	if (name.length <= maxLength) return name
	return `${name.slice(0, maxLength)}...`
}

export const isFileMatch = (
	file: MediaFileProps,
	selectedFile: MediaFileProps
) =>
	selectedFile.id === file.id ||
	(!!selectedFile.losId && selectedFile.losId === file.losId)
